import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — as a registered courier, we handle it for you",
      "Ideal for University of Arizona students studying abroad",
      "Perfect for Davis-Monthan AFB military families on PCS orders",
      "Great for Raytheon engineers on overseas missile system assignments",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Pima County post offices",
      "Good for planned international trips from TUS",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Tucson area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Phoenix",
      "NPIC appointment required — secure a slot before traveling",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function TucsonProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Tucson"
      headingExtra="AZ"
      introText="Tucson and Southern Arizona travelers — University of Arizona students studying abroad across 60+ countries, Davis-Monthan AFB military families deploying on short-notice orders (home of the A-10 Thunderbolt II fleet), Raytheon Missile Systems engineers traveling to allied nations for weapons system integration, Tucson International Airport (TUS) flyers heading to Mexico and beyond, and UA College of Medicine physicians attending international conferences — have several options for getting a passport fast. Here is how they compare, and why most Southern Arizona residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the need to travel to Phoenix."
      options={options}
      emergencyDescription="Davis-Monthan AFB is home to the 355th Wing and the A-10 Thunderbolt II close air support fleet — aircrew and maintainers deploy worldwide on short-notice orders. A Raytheon engineer supporting a Patriot missile system deployment to a NATO ally cannot wait for Phoenix's single agency. Traveling to Phoenix and back is a full-day commitment through unpredictable desert conditions. An A-10 crew chief deploying to an overseas forward operating base cannot gamble that Phoenix's single agency — shared with 5M metro residents — has an appointment slot."
      disclaimerText="*Processing speed depends on eligibility and documentation. Tucson does not have a regional passport agency — the closest is Phoenix. Not all applicants qualify for Regional Agency Processing."
    />
  );
}